export function verificarSeAlgoEstaPreenchido(
  formulario: any,
  setOpenPopover: Function,
  onClose: Function
) {
  let nome: boolean = String(formulario?.nome ?? '') !== ''
  let cpf: boolean = String(formulario?.cpf ?? '') !== ''
  let cnpj: boolean = String(formulario?.cnpj ?? '') !== ''
  let rg: boolean = String(formulario?.rg ?? '').toUpperCase() !== ''
  let orgao_expedidor: boolean = String(formulario?.orgao_expedidor ?? '') !== ''
  let email: boolean = String(formulario?.email ?? '') !== ''
  let sexo: boolean = String(formulario?.sexo ?? '') !== ''
  let nacionalidade: boolean = String(formulario?.nacionalidade ?? '') !== ''
  let escolaridade: boolean = String(formulario?.escolaridade ?? '') !== ''
  let profissao: boolean = String(formulario?.profissao ?? '') !== ''
  let estado_civil: boolean = String(formulario?.estado_civil ?? '') !== ''
  let celular: boolean = String(formulario?.celular ?? '') !== ''
  let fixo: boolean = String(formulario?.fixo ?? '') !== ''
  let cep: boolean = String(formulario?.cep ?? '') !== ''
  let estado: boolean = String(formulario?.estado ?? '') !== ''
  let cidade: boolean = String(formulario?.cidade ?? '') !== ''
  let bairro: boolean = String(formulario?.bairro ?? '') !== ''
  let logradouro: boolean = String(formulario?.logradouro ?? '') !== ''
  let numero: boolean = String(formulario?.numero ?? '') !== ''
  let complemento: boolean = String(formulario?.complemento ?? '') !== ''
  let outros: boolean = String(formulario?.outros ?? '') !== ''

  const possui_campo_preenchido: boolean = Object.values({
    nome,
    cpf,
    cnpj,
    rg,
    orgao_expedidor,
    email,
    sexo,
    nacionalidade,
    escolaridade,
    profissao,
    estado_civil,
    celular,
    fixo,
    cep,
    estado,
    cidade,
    bairro,
    logradouro,
    numero,
    complemento,
    outros,
  }).includes(true)

  if (possui_campo_preenchido) {
    setOpenPopover(true)
  } else {
    onClose(false)
  }
}

export function verificarSeHouveAlteracoes(
  original: any,
  formulario: any,
  setOpenPopover: Function,
  onClose: Function
) {
  console.log(original, formulario)
  let nome: boolean = String(original?.nome ?? '') === String(formulario?.nome ?? '')
  console.log('nome', nome, original?.nome, formulario?.nome)
  let cpf: boolean = String(original?.cpf ?? '') === String(formulario?.cpf ?? '')
  console.log('cpf', cpf, original?.nome, formulario?.nome)
  let cnpj: boolean = String(original?.cnpj ?? '') === String(formulario?.cnpj ?? '')
  console.log('cnpj', cnpj)
  let rg: boolean = String(original?.rg ?? '') === String(formulario?.rg ?? '')
  console.log('rg', rg)
  let orgao_expedidor: boolean =
    String(original?.orgao_expedidor ?? '') === String(formulario?.orgao_expedidor ?? '')
    console.log('orgao_expedidor', orgao_expedidor)
  let email: boolean = String(original?.email ?? '') === String(formulario?.email ?? '')
  console.log('email', email)
  let sexo: boolean = String(original?.sexo ?? '') === String(formulario?.sexo ?? '')
  console.log('sexo', sexo)
  let nacionalidade: boolean =
    String(original?.nacionalidade ?? '') === String(formulario?.nacionalidade ?? '')
    console.log('nacionalidade', nacionalidade)
  let escolaridade: boolean =
    String(original?.escolaridade ?? '') === String(formulario?.escolaridade ?? '')
    console.log('escolaridade', escolaridade)
  let profissao: boolean = String(original?.profissao ?? '') === String(formulario?.profissao ?? '')
  console.log('profissao', profissao)
  let estado_civil: boolean =
    String(original?.estado_civil ?? '') === String(formulario?.estado_civil ?? '')
    console.log('estado_civil', estado_civil)
  let celular: boolean = String(original?.celular ?? '') === String(formulario?.celular ?? '')
  console.log('celular', celular)
  let fixo: boolean = String(original?.fixo ?? '') === String(formulario?.fixo ?? '')
  console.log('fixo', fixo)
  let cep: boolean = String(original?.cep ?? '') === String(formulario?.cep ?? '')
  console.log('cep', cep)
  let estado: boolean = String(original?.estado ?? '') === String(formulario?.estado ?? '')
  console.log('estado', estado)
  let cidade: boolean = String(original?.cidade ?? '') === String(formulario?.cidade ?? '')
  console.log('cidade', cidade)
  let bairro: boolean = String(original?.bairro ?? '') === String(formulario?.bairro ?? '')
  console.log('bairro', bairro)
  let logradouro: boolean =
    String(original?.logradouro ?? '') === String(formulario?.logradouro ?? '')
    console.log('logradouro', logradouro)
  let numero: boolean = String(original?.numero ?? '') === String(formulario?.numero ?? '')
  console.log('numero', numero)
  let complemento: boolean =
    String(original?.complemento ?? '') === String(formulario?.complemento ?? '')
    console.log('complemento', complemento)
  let outros: boolean = String(original?.outros ?? '') === String(formulario?.outros ?? '')
  console.log('outros', outros)
  let nascimento: boolean =
    String(original?.nascimento ?? '') === String(formulario?.nascimento ?? '')
    console.log('nascimento', nascimento)

  // let tipo_motorizado: boolean = Boolean(original?.motorizado ?? 0) === Boolean(original?.tipo_motorizado ?? 0);

  const possui_campo_alterado: boolean = Object.values({
    nome,
    cpf,
    cnpj,
    rg,
    orgao_expedidor,
    email,
    sexo,
    nacionalidade,
    escolaridade,
    profissao,
    estado_civil,
    celular,
    fixo,
    cep,
    estado,
    cidade,
    bairro,
    logradouro,
    numero,
    complemento,
    outros,
    nascimento,
  }).includes(false)
  if (possui_campo_alterado) {
    setOpenPopover(true)
  } else {
    onClose(false)
  }
}
